/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { ActiveOrderProjectFromJSON, AssociateActiveOrderProjectDtoToJSON, ContractOrderOutputDtoFromJSON, ContractOrderOutputListDtoFromJSON, ContractOrderSFSearchInputDtoToJSON, ContractOrderSearchDtoToJSON, CreateContractOrderAttivoDtoToJSON, FilterProjectMonthDtoToJSON, FilterProjectMonthValuesDtoFromJSON, ListProjectCLDtoFromJSON, OrderSFSearchFilterDtoFromJSON, OtherCostListDtoFromJSON, OtherCostListDtoToJSON, ProjectMonthListDtoFromJSON, ProjectMonthListDtoToJSON, } from '../models/index';
/**
 *
 */
export class ControllerPerLeFunzioniDedicateAlControlloDelResponsabileDiContrattoApi extends runtime.BaseAPI {
    /**
     * Associa un ordine SF a un progetto attivo con validazione accesso per struttura business
     * Associa ordine a progetto per CL/AM
     */
    clAssociateOrderProjectRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['associateActiveOrderProjectDto'] == null) {
                throw new runtime.RequiredError('associateActiveOrderProjectDto', 'Required parameter "associateActiveOrderProjectDto" was null or undefined when calling clAssociateOrderProject().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cl/orders/associate-project`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: AssociateActiveOrderProjectDtoToJSON(requestParameters['associateActiveOrderProjectDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ActiveOrderProjectFromJSON(jsonValue));
        });
    }
    /**
     * Associa un ordine SF a un progetto attivo con validazione accesso per struttura business
     * Associa ordine a progetto per CL/AM
     */
    clAssociateOrderProject(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.clAssociateOrderProjectRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Crea un nuovo ordine ciclo attivo con validazione accesso per struttura business
     * Crea ordine ciclo attivo per CL/AM
     */
    clCreateOrderRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['createContractOrderAttivoDto'] == null) {
                throw new runtime.RequiredError('createContractOrderAttivoDto', 'Required parameter "createContractOrderAttivoDto" was null or undefined when calling clCreateOrder().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cl/orders/create`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateContractOrderAttivoDtoToJSON(requestParameters['createContractOrderAttivoDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ContractOrderOutputDtoFromJSON(jsonValue));
        });
    }
    /**
     * Crea un nuovo ordine ciclo attivo con validazione accesso per struttura business
     * Crea ordine ciclo attivo per CL/AM
     */
    clCreateOrder(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.clCreateOrderRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Restituisce i possibili valori per le select di ricerca ordini
     * Recupera filtri di ricerca ordini per CL/AM
     */
    clGetOrderSearchFiltersRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cl/orders/search-filters`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => OrderSFSearchFilterDtoFromJSON(jsonValue));
        });
    }
    /**
     * Restituisce i possibili valori per le select di ricerca ordini
     * Recupera filtri di ricerca ordini per CL/AM
     */
    clGetOrderSearchFilters(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.clGetOrderSearchFiltersRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Consente al CL o SUPER ADMIN di modificare i valori di ricavo e costi anche per mesi consolidati
     * Modifica i valori per i progetti passati in input
     */
    clProjectMonthEditRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectMonthListDto'] == null) {
                throw new runtime.RequiredError('projectMonthListDto', 'Required parameter "projectMonthListDto" was null or undefined when calling clProjectMonthEdit().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cl/project/edit`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ProjectMonthListDtoToJSON(requestParameters['projectMonthListDto']),
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Consente al CL o SUPER ADMIN di modificare i valori di ricavo e costi anche per mesi consolidati
     * Modifica i valori per i progetti passati in input
     */
    clProjectMonthEdit(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.clProjectMonthEditRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Recupera tutti i progetti applicando i filtri passati in input
     * Recupera tutti i progetti tramite i filtri
     */
    clProjectMonthSearchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['year'] == null) {
                throw new runtime.RequiredError('year', 'Required parameter "year" was null or undefined when calling clProjectMonthSearch().');
            }
            if (requestParameters['month'] == null) {
                throw new runtime.RequiredError('month', 'Required parameter "month" was null or undefined when calling clProjectMonthSearch().');
            }
            if (requestParameters['filterProjectMonthDto'] == null) {
                throw new runtime.RequiredError('filterProjectMonthDto', 'Required parameter "filterProjectMonthDto" was null or undefined when calling clProjectMonthSearch().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cl/project/year/{year}/month/{month}`.replace(`{${"year"}}`, encodeURIComponent(String(requestParameters['year']))).replace(`{${"month"}}`, encodeURIComponent(String(requestParameters['month']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: FilterProjectMonthDtoToJSON(requestParameters['filterProjectMonthDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ProjectMonthListDtoFromJSON(jsonValue));
        });
    }
    /**
     * Recupera tutti i progetti applicando i filtri passati in input
     * Recupera tutti i progetti tramite i filtri
     */
    clProjectMonthSearch(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.clProjectMonthSearchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Recupera tutti i filtri applicabili per la ricerca per un progetto
     * Recupera tutti i filtri di ricerca
     */
    clProjectMonthSearchFiltersRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cl/search-filters-values`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => FilterProjectMonthValuesDtoFromJSON(jsonValue));
        });
    }
    /**
     * Recupera tutti i filtri applicabili per la ricerca per un progetto
     * Recupera tutti i filtri di ricerca
     */
    clProjectMonthSearchFilters(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.clProjectMonthSearchFiltersRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Consente al CL o SUPER ADMIN di visualizzare i costi esterni di un progetto
     * Altri costi
     */
    clProjectOtherCostsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['idProject'] == null) {
                throw new runtime.RequiredError('idProject', 'Required parameter "idProject" was null or undefined when calling clProjectOtherCosts().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cl/project/{idProject}/other-costs`.replace(`{${"idProject"}}`, encodeURIComponent(String(requestParameters['idProject']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => OtherCostListDtoFromJSON(jsonValue));
        });
    }
    /**
     * Consente al CL o SUPER ADMIN di visualizzare i costi esterni di un progetto
     * Altri costi
     */
    clProjectOtherCosts(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.clProjectOtherCostsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Aggiorna i costi esterni di un progetto
     * Aggiorna i costi esterni
     */
    clProjectOtherCostsUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['idProject'] == null) {
                throw new runtime.RequiredError('idProject', 'Required parameter "idProject" was null or undefined when calling clProjectOtherCostsUpdate().');
            }
            if (requestParameters['otherCostListDto'] == null) {
                throw new runtime.RequiredError('otherCostListDto', 'Required parameter "otherCostListDto" was null or undefined when calling clProjectOtherCostsUpdate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cl/project/{idProject}/other-costs/update`.replace(`{${"idProject"}}`, encodeURIComponent(String(requestParameters['idProject']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: OtherCostListDtoToJSON(requestParameters['otherCostListDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => OtherCostListDtoFromJSON(jsonValue));
        });
    }
    /**
     * Aggiorna i costi esterni di un progetto
     * Aggiorna i costi esterni
     */
    clProjectOtherCostsUpdate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.clProjectOtherCostsUpdateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Recupera tutti i progetti di un determinato CL applicando i filtri passati in input
     * Recupera tutti i progetti di un determinato CL tramite i filtri
     */
    clProjectSearchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['filterProjectMonthDto'] == null) {
                throw new runtime.RequiredError('filterProjectMonthDto', 'Required parameter "filterProjectMonthDto" was null or undefined when calling clProjectSearch().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cl/project/search`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: FilterProjectMonthDtoToJSON(requestParameters['filterProjectMonthDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ListProjectCLDtoFromJSON(jsonValue));
        });
    }
    /**
     * Recupera tutti i progetti di un determinato CL applicando i filtri passati in input
     * Recupera tutti i progetti di un determinato CL tramite i filtri
     */
    clProjectSearch(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.clProjectSearchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Restituisce ordini visibili all\'utente in base alla gerarchia business
     * Ricerca ordini ciclo attivo per CL/AM
     */
    clSearchOrdersRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['contractOrderSearchDto'] == null) {
                throw new runtime.RequiredError('contractOrderSearchDto', 'Required parameter "contractOrderSearchDto" was null or undefined when calling clSearchOrders().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cl/orders/search`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ContractOrderSearchDtoToJSON(requestParameters['contractOrderSearchDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ContractOrderOutputListDtoFromJSON(jsonValue));
        });
    }
    /**
     * Restituisce ordini visibili all\'utente in base alla gerarchia business
     * Ricerca ordini ciclo attivo per CL/AM
     */
    clSearchOrders(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.clSearchOrdersRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Restituisce ordini SF visibili all\'utente in base alla gerarchia business
     * Ricerca ordini Salesforce per CL/AM
     */
    clSearchOrdersSFRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['contractOrderSFSearchInputDto'] == null) {
                throw new runtime.RequiredError('contractOrderSFSearchInputDto', 'Required parameter "contractOrderSFSearchInputDto" was null or undefined when calling clSearchOrdersSF().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cl/orders/search-sf`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ContractOrderSFSearchInputDtoToJSON(requestParameters['contractOrderSFSearchInputDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ContractOrderOutputListDtoFromJSON(jsonValue));
        });
    }
    /**
     * Restituisce ordini SF visibili all\'utente in base alla gerarchia business
     * Ricerca ordini Salesforce per CL/AM
     */
    clSearchOrdersSF(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.clSearchOrdersSFRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Restituisce il dettaglio degli ordini SF visibili all\'utente in base alla gerarchia business
     * Dettaglio ordini Salesforce per CL/AM
     */
    clSearchOrdersSFDetailRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['contractOrderSFSearchInputDto'] == null) {
                throw new runtime.RequiredError('contractOrderSFSearchInputDto', 'Required parameter "contractOrderSFSearchInputDto" was null or undefined when calling clSearchOrdersSFDetail().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cl/orders/search-sf-detail`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ContractOrderSFSearchInputDtoToJSON(requestParameters['contractOrderSFSearchInputDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ContractOrderOutputListDtoFromJSON(jsonValue));
        });
    }
    /**
     * Restituisce il dettaglio degli ordini SF visibili all\'utente in base alla gerarchia business
     * Dettaglio ordini Salesforce per CL/AM
     */
    clSearchOrdersSFDetail(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.clSearchOrdersSFDetailRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Cambia lo stato di un progetto in ECONOMICS_CLOSE
     */
    closeEconomicsProjectRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling closeEconomicsProject().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cl/{projectId}/closeEconomicsProject`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Cambia lo stato di un progetto in ECONOMICS_CLOSE
     */
    closeEconomicsProject(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.closeEconomicsProjectRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
